import { Component, Input, OnInit } from '@angular/core';
import { PriceTargetsComps } from '../../models';

@Component({
    selector: 'rms-company-comporator-flag',
    templateUrl: './company-comporator-flag.component.html',
    styleUrls: ['./company-comporator-flag.component.scss'],
    standalone: false
})
export class CompanyComporatorFlagComponent implements OnInit {
  @Input() priceComp: PriceTargetsComps = { priceTarget: null, companyComparatorId: null};
  @Input() placement: 'top' | 'top-left' | 'top-right' | 'bottom' | 'bottom-left' | 'bottom-right' |
    'left' | 'left-top' | 'left-bottom' | 'right' | 'right-top' | 'right-bottom'
    = 'top';

  constructor() { }

  ngOnInit() {
  }

}
